import React, { ReactNode } from "react";
import { Helmet } from "react-helmet";

function NoIndexWrap({ children }: Readonly<{ children: ReactNode }>) {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      {children}
    </>
  );
}

export default NoIndexWrap;
